import paths from 'routing/routes/_paths';

import AiLogs from 'views/ai-logs';

const aiLogsRoutes = [
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.ai_logs,
    component: AiLogs,
    documentTitle: 'AI Logs'
  }
];

export default aiLogsRoutes;
